export default "__VITE_ASSET__CZGFbfy2__"